import { getRaw, postRaw } from "@/lib/api";

// ============================================================================
// DTOs (mirror ExternalQuote* contracts — public / anonymous endpoints)
// ============================================================================

export type ExternalQuoteLineDto = {
  description: string;
  quantity: number;
  unitPriceExGst: number;
  lineTotalExGst: number;
};

export type ExternalQuoteOptionDto = {
  description: string;
  priceDelta: number;
  isSelectedDefault: boolean;
};

export type ExternalQuoteIncludeDto = {
  description: string;
  included: boolean;
};

export type ExternalQuoteViewDto = {
  quoteRef: string;
  status: string;
  version: number;
  customerName: string;
  description: string | null;
  validUntil: string | null;
  totalExGst: number;
  gst: number;
  totalIncGst: number;
  lines: ExternalQuoteLineDto[];
  options: ExternalQuoteOptionDto[];
  includes: ExternalQuoteIncludeDto[];
  termsAndConditionsHtml: string | null;
};

export type ExternalApprovalRequest = { externalEmail: string; comment?: string };
export type ExternalRejectionRequest = { externalEmail: string; reason: string };

// ============================================================================
// API helpers — unauthenticated (token-scoped public endpoints)
// ============================================================================

export const getExternalQuote = (token: string): Promise<ExternalQuoteViewDto> =>
  getRaw<ExternalQuoteViewDto>(`/api/external/quote-approval/${token}`);

export const approveExternalQuote = (token: string, body: ExternalApprovalRequest): Promise<void> =>
  postRaw(`/api/external/quote-approval/${token}/approve`, body) as Promise<void>;

export const rejectExternalQuote = (token: string, body: ExternalRejectionRequest): Promise<void> =>
  postRaw(`/api/external/quote-approval/${token}/reject`, body) as Promise<void>;
